export default () => {
  try {
    const userId = sessionStorage.getItem('userId');
    if (!userId) {
      return localStorage.getItem('usersPreferences') ?? '{}';
    }
    const updatedAccountSettings = JSON.parse(localStorage.getItem('accountSettings'));
    const usersPreferences = JSON.parse(localStorage.getItem('usersPreferences')) ?? {};
    const { settings: currentUserSettings } = usersPreferences?.[userId] ?? {};
    const { accounts: currentAccountSettings } = currentUserSettings ?? {};
    const updatedUserSettings = {
      settings: {
        ...currentUserSettings,
        lastAccount: sessionStorage.getItem('currentAccountId'),
        accounts: { ...currentAccountSettings, ...updatedAccountSettings },
      },
    };
    const updatedUserPreferences = { ...usersPreferences, [userId]: updatedUserSettings };
    return JSON.stringify(updatedUserPreferences);
  } catch (e) {
    // if there is an error it is likely caused by invalid JSON. In this case we should return
    // userPreferences back to a clean state.
    return '{}';
  }
};
